module.exports = __webpack_public_path__ + "static/media/expand_vendor_trace.76743891.svg";